const CheckNotNull = Symbol("CheckNotNull");

class EventCategory {
    public event_categoryID: string = '';
    public event_category_name: string = '';
    public event_category_desc: string = '';
    public event_category_type: number = 0;

    constructor(
        event_categoryID: string,
        event_category_name: string,
        event_category_desc: string,
        event_category_type: string
    ) {
        this.event_categoryID = this[CheckNotNull](event_categoryID) ? event_categoryID : '';
        this.event_category_name = this[CheckNotNull](event_category_name) ? event_category_name : '';
        this.event_category_desc = this[CheckNotNull](event_category_desc) ? event_category_desc : '';
        this.event_category_type = this[CheckNotNull](event_category_type) ? parseInt(event_category_type) : 0;
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    } 
}
export default EventCategory;